"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect } from "react";

/**
 * Props for the useAccessibility hook
 */
interface UseAccessibilityProps {
  /** Whether the component is in an active/enabled state */
  isActive: boolean;
  /** Callback to handle area click */
  onAreaClick: () => void;
  /** Whether reduced motion is preferred */
  prefersReducedMotion?: boolean;
}

/**
 * Interface for the return value of the useAccessibility hook
 */
interface AccessibilityHandlers {
  /** Handler for keyboard events */
  handleKeyDown: (e: React.KeyboardEvent<HTMLDivElement>) => void;
  /** Handler for touch start events */
  handleTouchStart: () => void;
  /** Handler for touch end events */
  handleTouchEnd: () => void;
}

/**
 * Hook for managing accessibility features
 *
 * Provides keyboard navigation, touch handling, and focus management
 * to ensure the component is accessible.
 *
 * @param props Hook props
 * @returns Object with ref and event handlers
 */
const useAccessibility = t0 => {
  const $ = _c(19);
  const {
    isActive,
    onAreaClick,
    prefersReducedMotion: t1
  } = t0;
  const prefersReducedMotion = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== prefersReducedMotion) {
    t2 = typeof prefersReducedMotion !== "undefined" ? prefersReducedMotion : typeof window !== "undefined" ? window.matchMedia("(prefers-reduced-motion: reduce)").matches : false;
    $[0] = prefersReducedMotion;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const detectedReducedMotion = t2;
  let t3;
  if ($[2] !== isActive || $[3] !== onAreaClick) {
    t3 = e => {
      if ((e.key === "Enter" || e.key === " ") && isActive) {
        e.preventDefault();
        onAreaClick();
      }
    };
    $[2] = isActive;
    $[3] = onAreaClick;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleKeyDown = t3;
  let t4;
  if ($[5] !== detectedReducedMotion || $[6] !== isActive) {
    t4 = () => {
      if (isActive && !detectedReducedMotion) {}
    };
    $[5] = detectedReducedMotion;
    $[6] = isActive;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const handleTouchStart = t4;
  let t5;
  if ($[8] !== detectedReducedMotion || $[9] !== isActive) {
    t5 = () => {
      if (isActive && !detectedReducedMotion) {}
    };
    $[8] = detectedReducedMotion;
    $[9] = isActive;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleTouchEnd = t5;
  let t6;
  if ($[11] !== handleTouchEnd || $[12] !== handleTouchStart || $[13] !== isActive) {
    t6 = [isActive, handleTouchStart, handleTouchEnd];
    $[11] = handleTouchEnd;
    $[12] = handleTouchStart;
    $[13] = isActive;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  useEffect(_temp2, t6);
  let t7;
  if ($[15] !== handleKeyDown || $[16] !== handleTouchEnd || $[17] !== handleTouchStart) {
    t7 = {
      handleKeyDown,
      handleTouchStart,
      handleTouchEnd
    };
    $[15] = handleKeyDown;
    $[16] = handleTouchEnd;
    $[17] = handleTouchStart;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
};
export default useAccessibility;
function _temp() {}
function _temp2() {
  return _temp;
}